define.alias("shared/components/shared/pre-boarding/survey/index", "preview-grid/components/shared/pre-boarding/survey/index");